import { types } from 'mobx-state-tree';

import IsoDate from '../types/IsoDate';
import EmailAddress from '../types/EmailAddress';


const Employment = types.model('Employment', {
    jobTitle: types.maybe(types.string),
    jobDescription: types.maybe(types.string),
    employer: types.maybe(types.string),
    income: types.maybe(types.integer),
    industry: types.maybe(types.string),
    employerName: types.maybe(types.string),
    current: types.maybe(types.boolean),
    startDate: types.maybe(IsoDate),
    endDate: types.maybe(IsoDate),
    phone: types.maybe(types.string),
    phoneExt: types.maybe(types.string),
    workEmail: types.maybe(EmailAddress),
});

export default Employment;
